<template lang="pug">
  v-container
    v-row(cols='12' )
      v-col(xs='12' md='8')
        v-container
          tabla_ordenes_de_compras
      v-col(xs='12' md='4' ) 
        v-container#scroll-target.overflow-y-auto(style='max-height: 700px')  
          TablaDeRequerimientos 
          v-row
            v-card.mb-5(elevation='0')
              v-card-title
                h6.mb-3 Cotizaciones
                v-spacer
                Registrar_cotizacion 
                v-text-field(v-model='search' append-icon='fa-search' label='Buscar cotizaciones' single-line hide-details)
              v-data-table.elevation-1(:headers='headers' :items='registro_cotizaciones' :search='search' sort-by='numero_de_operacion')
                template( v-slot:item.numeración="{item}" )
                  span Cotizacion Nº {{item.numeración}}
                template( v-slot:item.action="{item}")
                  estado_de_botones(:estado_del_documento = 'item.estado_del_documento' :id = 'item.key')  
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import {db} from '@/FirebaseConfig'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nº',  value: 'numero_de_operacion' },
      { text: '', value: 'action', sortable: false }
    ],
    record: [],
  }),
  methods: {
    ...mapActions({
      editItem: 'Cotizaciones/get',
      deleteItem: 'Cotizaciones/clean',
      save: 'Cotizaciones/add',
    }),
  },
  computed: {
     ...mapState({
      Cotizaciones :state=> state.Cotizaciones,
    }),
    ...mapGetters({
      registro_cotizaciones: 'Cotizaciones/registro',
    })
  },
  
  components:{
    estado_de_botones: ()=>import('../.././componentes/estado_de_botones'),
    TablaDeRequerimientos: ()=>import('../.././componentes/tabla_de_requerimientos'),
    Registrar_cotizacion: () => import('../../componentes/Registrar_cotizacion'),
    tabla_ordenes_de_compras: () => import('../../componentes/tabla_ordenes_de_compras'),
    Registrar_cotizacion: () => import('../../componentes/Registrar_cotizacion')

  }
}
</script>
